import { useRouterStore } from '~/stores/RouterStore'

export const useProductPageStore = defineStore('product_page_store', () => {
    const routerStore = useRouterStore()

    const product = ref({})
    const ratingInfo = ref({ count: 0 })
    const ratings = ref({})
    const recommendations = ref([])
    const relatedProducts = ref([])
    const specifications = ref([])
    const shippingPrice = ref(0)
    const fallbackImage = ref('')
    const showBuyBack = ref(false)

    const setProduct = (path) => {
        const page = routerStore.getPage(path)
        product.value = page.product
        ratingInfo.value = page.rating_info || { count: 0 }
        ratings.value = page.ratings
        recommendations.value = page.recommendations
        relatedProducts.value = page.related_products
        specifications.value = page.product.specifications
        shippingPrice.value = page.shipping_price
        fallbackImage.value = page.fallback_image
        showBuyBack.value = page.product.buy_back_enabled
    }

    return {
        product,
        ratingInfo,
        ratings,
        recommendations,
        relatedProducts,
        specifications,
        shippingPrice,
        fallbackImage,
        setProduct,
        showBuyBack
    }
})
